import * as React from 'react';
import { useContext } from 'react';

import type {
  Seo_FooterCategory as SeoFooterCategory,
  Seo_MegaMenu as SeoMegaMenu,
  Seo_MetaTags as SeoMetaTags,
} from '__generated__/graphql-types-do-not-use';

import type { SeoPathConfigurationQuery_EqpDataFragment as SeoEqpData } from 'bundles/seo/api/__generated__/SeoPathConfigurationQuery';
import type { GlobalFooterLinksForCategory } from 'bundles/seo/types';

type SeoPageDataContextType = {
  subfooter?: SeoFooterCategory[];
  globalFooterLinksForCategory?: GlobalFooterLinksForCategory;
  metaTags?: SeoMetaTags;
  megaMenu?: SeoMegaMenu;
  eqpData?: SeoEqpData | null;
  loading?: boolean;
};

const SeoPageDataContext = React.createContext<SeoPageDataContextType>({});

export const useSeoPageData = () => useContext(SeoPageDataContext);

export const SeoPageDataContextProvider = ({
  subfooter,
  globalFooterLinksForCategory,
  metaTags,
  megaMenu,
  eqpData,
  loading,
  children,
}: React.PropsWithChildren<SeoPageDataContextType>) => {
  return (
    <SeoPageDataContext.Provider
      value={{ subfooter, globalFooterLinksForCategory, metaTags, megaMenu, eqpData, loading }}
    >
      {children}
    </SeoPageDataContext.Provider>
  );
};
